<template lang="html">
  <div class="main-settings">
    <div class="section-header">
      <h2>Settings</h2>

      <div class="actions" v-if="isCommissioner && !editing">
        <button
          class="small"
          @click="refreshRankings"
        >
          Refresh rankings
        </button>

        <button
          class="small edit"
          @click="editSettings"
        >
          Edit
        </button>
      </div>

      <div class="actions" v-if="editing">
        <a @click="cancel">Cancel</a>

        <button class="small edit" @click="save">
          Save
        </button>
      </div>
    </div>

    <section class="display" v-if="!editing">
      <div class="setting">
        <label>Rounds</label>
        <div class="value">{{ draft.rounds }}</div>
      </div>

      <div class="setting">
        <label>Type</label>
        <div class="value">{{ draft.type }}</div>
      </div>

      <div class="setting">
        <label>Pick duration</label>
        <div class="value">{{ draft.duration }} seconds</div>
      </div>

      <div class="setting">
        <label>Rankings</label>
        <div class="value">{{ draft.baseRanking.label }}</div>
      </div>
    </section>

    <section v-else>
      <form>
        <div class="setting">
          <label>Draft name</label>
          <input
            type="text"
            required
            maxlength="20"
            placeholder="League name"
            v-model="draftForm.name"
          >
        </div>
        <div class="setting">
          <label>Draft rounds</label>
          <multiselect v-model="draftForm.rounds" :options="roundOptions" />
        </div>

        <div class="setting">
          <label>Draft type</label>
          <multiselect v-model="draftForm.type" :options="typeOptions" label="label"  />
        </div>

        <div class="setting">
          <label>Pick duration</label>
          <multiselect v-model="draftForm.duration" :options="durationOptions" />
        </div>

        <div class="setting" v-if="baseRankingOptions.length">
          <label>Rankings</label>
          <multiselect
            v-model="draftForm.baseRanking"
            label="label"
            :options="baseRankingOptions"
          />
        </div>
      </form>

      <br />

      <button class="small edit" @click="save">
        Save
      </button>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import clonedeep from 'lodash.clonedeep';

export default {
  data() {
    return {
      editing: false,
      draftForm: {},
    };
  },

  created() {
    this.$store.dispatch('rankings/LOAD_BASE_RANKINGS');
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      teamOptions: ({ draft }) => draft.teamOptions,
      durationOptions: ({ draft }) => draft.durationOptions,
      typeOptions: ({ draft }) => draft.typeOptions,
      roundOptions: ({ draft }) => draft.roundOptions,
    }),

    ...mapGetters({
      isCommissioner: 'draft/isCommissioner',
      baseRankingOptions: 'rankings/baseRankingOptions',
    }),
  },

  methods: {
    editSettings() {
      this.draftForm = clonedeep(this.draft);
      this.draftForm.type = this.typeOptions.find(({ value }) => value === this.draftForm.type);
      this.editing = true;
    },

    refreshRankings() {
      this.$store.dispatch('draft/SETUP_DRAFT')
        .then(() => {
          this.$toast({ message: 'Rankings are up to date' });
        })
        .catch(() => {});
    },

    cancel() {
      this.editing = false;
    },

    save() {
      this.editing = false;

      this.$store.dispatch('draft/SAVE_DRAFT', this.draftForm)
        .then(() => {
          this.$toast({ message: 'Saved your draft settings' });
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "./settings";

  .main-settings {
    @include settingSection;
  }
</style>
